module.exports = __webpack_public_path__ + "img/Tennos-logo-w.49eb49f9.png";